// frontend/src/config/content.js

export const content = {
  // Infos générales (utilisées dans le footer, header, meta)
  identity: {
    name: "Laetitia Lacroix",
    title: "Diététicienne Nutritionniste",
    rpps: "10 111 54 74 68",
    email: "contact@laetitialacroix.fr",
    phone: "06 51 03 43 23",
    address_main: "Cabinet Doc City, 83600 Fréjus",
  },

  // Section 1 : Hero (Haut de page)
  hero: {
    welcome: "BIENVENUE",
    title: "Laetitia Lacroix",
    subtitle: "Diététicienne Nutritionniste",
    image: "/images/hero-cabinet.jpg"
  },

  // Section 2 : Philosophie
  philosophy: {
    title: "Ma philosophie",
    subtitle: "Retrouvez durablement votre santé en vous faisant plaisir!",
    text: [
      "Diététicienne passionnée, je vous accompagne avec </br><strong>une écoute attentive</strong> et <strong>une approche 100% personnalisée.</strong>",
      "Mon objectif : Concilier le respect de vos besoins et la joie de manger au quotidien, en toute simplicité."
    ],
    quote: "“Ma philosophie en deux mots : <strong>Equilibre & plaisir.</strong>”",
    image: "/images/portrait-philo.jpg"
  },

  // Section 3 : Spécialités (Grille d'images)
  specialties: {
    title: "Consultation adaptée",
    items: [
      { label: "Bilan nutritionnel", image: "/images/spec-bilan.jpg" },
      { label: "Poids", image: "/images/spec-poids.jpg" },
      { label: "Grossesse", image: "/images/spec-grossesse.jpg" },
      { label: "Sportif", image: "/images/spec-sportif.jpg" },
      { label: "Sénior", image: "/images/spec-senior.jpg" },
      { label: "Enfant", image: "/images/spec-enfant.jpg" },
      { label: "Pathologies", image: "/images/spec-pathologies.jpg" },
      { label: "Oncologie", image: "/images/spec-oncologie.jpg" },
      { label: "Cardiovasculaires", image: "/images/spec-cardio.jpg" },
      { label: "Digestives", image: "/images/spec-digestives.jpg" },
      { label: "Diabète\nDyslipidémie\nHypertension", image: "/images/spec-metabolique.jpg" },
      { label: "Hormonales\nEndométriose\nMénopause", image: "/images/spec-hormonales.png" },
      { label: "Anémie\nHémochromatose", image: "/images/spec-anemie.png" },
      { label: "Dénutrition", image: "/images/spec-denutrition.jpg" },
      { label: "Intolérances \nallergies alimentaires", image: "/images/spec-intolerances.jpg" }
    ]
  },

  // Section 4 : Lieux
  locations: {
    title: "Lieux de consultation",
    images: [
        "/images/loc-waiting-room.jpg",
        "/images/loc-bureau-laptop.jpg"
    ],
    list: [
      {
        name: "Cabinet Doc City",
        address: "237 Rue Jean Giono, 83600 Fréjus",
        details: "Bureau F - 2ème étage \n(Arrêt Bus Clinique des Lauriers)"
      },
      {
        name: "Cabinet Saint-Raphaël",
        address: "83700 Saint-Raphaël",
        details: "Boulevard Baudino"
      },
      {
        name: "Téléconsultation",
        address: "",
        details: "Pour vous répondre plus rapidement."
      },
      {
        name: "A domicile",
        address: "",
        details: "Pour certaines prises en charge diététiques thérapeutiques."
      }
    ]
  },

  // Section 5 : Tarifs & Approche
  pricing: {
    title: "Tarifs Consultation",
    items: [
      { label: "Première consultation", price: "60€" },
      { label: "Suivi", price: "40€" }
    ],
    certif: {
        text: "Laetitia Lacroix <strong>Diététicienne Nutritionniste diplômée d'Etat</strong> \nEnregistrée au <strong>répertoire national des professionnels de santé \n</strong> sous le Numéro <strong>RPPS 10 111 54 74 68</strong>",
        logo: "/images/logo-afdn.png"
    },
    refund: {
        title: "Remboursement ?",
        text: "La prestation n'est pas prise en charge par l'Assurance Maladie. </br> <strong>De nombreuses mutuelles prennent en charge </strong>les consultations diététiques. N’hésitez pas à vous renseigner auprès de votre mutuelle."
    }
  },

  approach: {
    title: "Plus qu’une consultation, un véritable accompagnement :",
    points: [
      "Une écoute attentive et humaine",
      "Des outils concrets et simples",
      "Des documents personnalisés après chaque séance",
      "Des idées de recettes adaptées",
      "Votre motivation boostée",
      "Un soutien durable"
    ],
    cta: "Prête à être accompagnée !\nRéservez votre premier créneau en quelques clics."
  },

  // Section 6 : Contact (Images décoratives)
  contact: {
    title: "Me contacter",
    images: [
        "/images/contact-hiver.jpg",
        "/images/Laeti_Burger.png"
    ],
    intro: "N’hésitez pas à me contacter pour toutes questions."
  }
};